import PostList from '@/modules/post/views/post/PostList.vue'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import PostDetail from '@/modules/post/views/post/PostDetail.vue'
import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
const baseRoute = OneNetworkConfig.baseRoutePath
const postRouter = [
  {
    path: `${baseRoute}/posts/posts`,
    name: 'posts',
    meta: {
      component: PostList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/posts/post/detail/:id`,
    name: 'post-detail',
    meta: {
      component: PostDetail
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/posts/post/create`,
    name: 'post-create',
    meta: {
      component: PostDetail
    },
    component: PrivateRouter,
  }
]

export default postRouter
